import axios from 'axios'

const defaultOptions: any = {
  baseURL: process.env.REACT_APP_POSTPAID_PARTNER_API,
}

const instanceOfPostpaidPartner = axios.create(defaultOptions)

instanceOfPostpaidPartner.interceptors.request.use((config) => {
  return {
    ...config,
    headers: {
      ...config.headers,
    },
  }
})

export default instanceOfPostpaidPartner
